<template>
    <el-dialog title="页面API" :visible.sync="centerDialogVisible" @close="cancel">
    <el-form ref="submitData" :model="submitData" label-width="120px" :rules="rules">
      <el-form-item label="API编号" prop="code">
        <el-input v-model="submitData.code" />
      </el-form-item>
      <el-form-item label="API名称" prop="name">
        <el-input v-model="submitData.name" />
      </el-form-item>
      <el-form-item label="API地址" prop="url">
        <el-input v-model="submitData.url" />
      </el-form-item>

    </el-form>
  
    <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" style="margin-right:8px">取消</el-button>
        <el-button type="primary"  @click="onSubmit('submitData')">确认</el-button>
      </span>
    </el-dialog>
</template>
<script>
import { lengthFifty, validateTwenty, validateTenNumber } from '@/api/validate'
import { createPage, search } from '@/api/system'
export default {
  props: ['menuId', 'clickType', 'apiId', 'pageId', 'appId'],
  data() {
    return {
      submitData: {
        code: '',
        name: '',
        appId: this.appId,
        menuType: 2,
        url: '',
        id: this.apiId,
        parentId: this.pageId
      },
      centerDialogVisible:true,
      rules: {
        code: [{
          required: true,
          validator: validateTenNumber,
          trigger: 'change'
        }],
        name: [{
          required: true,
          validator: validateTwenty,
          trigger: 'change'
        }],
        url: [{
          required: true,
          validator: lengthFifty,
          trigger: 'change'
        }]
      }
    }
  },
  mounted() {
    if (this.clickType == 1) {
      this.searchInfo()
    } else {
      this.submitData.id = ''
    }
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.create()
        } else {
          return false
        }
      })
    },
    create() {
      createPage(this.submitData).then(res => {
        if (res && res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('returnResult')
        } 
      })
    },
    cancel() {
      this.$emit('returnResult')
    },
    searchInfo() {
      search({
        id: this.apiId,
        menuType: 2
      }).then(res => {
        if (res && res.code == 0) {
          this.submitData.name = res.data[0].name
          this.submitData.code = res.data[0].code
          this.submitData.url = res.data[0].url
        }
      })
    }
  }
}
</script>
